import { createSlice } from '@reduxjs/toolkit'

import { fetchSpamChecksThunk } from '@app/store/spam/thunks'

import { initialState } from './constants'

const spamSlice = createSlice({
  name: 'spam',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSpamChecksThunk.fulfilled, (state, action) => {
      action.payload.events.forEach((e) => {
        state.spamChecks[e.id] = e
      })
      state.fetching = false
      return state
    })
    builder.addCase(fetchSpamChecksThunk.rejected, (state) => ({
      ...state,
      fetching: false,
    }))
    builder.addCase(fetchSpamChecksThunk.pending, (state) => ({
      ...state,
      fetching: true,
    }))
  },
})

export default spamSlice.reducer
